var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#D3EAFF",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 14.0833H17M12.8333 17H19.5M15.0698 22H20.5C21.9001 22 22.6002 22 23.135 21.7275C23.6054 21.4878 23.9878 21.1054 24.2275 20.635C24.5 20.1002 24.5 19.4001 24.5 18V13.5C24.5 12.0999 24.5 11.3998 24.2275 10.865C23.9878 10.3946 23.6054 10.0122 23.135 9.77248C22.6002 9.5 21.9001 9.5 20.5 9.5H13.5C12.0999 9.5 11.3998 9.5 10.865 9.77248C10.3946 10.0122 10.0122 10.3946 9.77248 10.865C9.5 11.3998 9.5 12.0999 9.5 13.5V23.9463C9.5 24.3903 9.5 24.6123 9.59102 24.7263C9.67019 24.8255 9.79022 24.8832 9.91712 24.8831C10.063 24.8829 10.2364 24.7442 10.5831 24.4668L12.571 22.8765C12.9771 22.5517 13.1801 22.3892 13.4062 22.2737C13.6068 22.1712 13.8204 22.0963 14.041 22.051C14.2897 22 14.5497 22 15.0698 22Z",
    stroke: "#278DEC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMessage);
export default __webpack_public_path__ + "static/media/avatarMessage.2fc620fac90e75ca18dec530d8a742dc.svg";
export { ForwardRef as ReactComponent };